export default __webpack_public_path__ + "static/media/AndriyM295.89387474.jpg";